import React, {useState} from 'react';

//import utils
import { Heading } from '../../style/heading';

//import styled
import { 
        StyledContainer,
        StyledFlexContainer,
        StyledPagination,
        StyledPaginationItem,
        StyledPaginationLink
} from './Projects_styled';

//import components
import ProjectData from '../../content/projectData';


import CardUI from './CardUI';


const Projects = () => {
    
    // state
    const [projects] = useState(ProjectData);
    const [currentPage, setCurrentPage] = useState(1);
    const [projectPerPage] = useState(6);


    const handleClick = (event) => {
        setCurrentPage(Number(event.target.id));
    }

    const handlePrev = (event) => {
        if(currentPage > 1) {
            setCurrentPage(currentPage-1);
        }
    }

    const handleNext = (event) => {
        const totalPage = Math.ceil(projects.length / projectPerPage);
        if (currentPage < totalPage ) {
            setCurrentPage(currentPage + 1);
        }
    }

    // pagination variable
    const indexOfLastProject = currentPage * projectPerPage;
    const indexOfFirstProject = indexOfLastProject - projectPerPage;
    const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);

        const renderProject = currentProjects.map((ProjectDetail, index) => (
        
            <CardUI
                key={index}
                image={ProjectDetail.image}
                name={ProjectDetail.name}
                type={ProjectDetail.type}
                date={ProjectDetail.date}
                description={ProjectDetail.description}
                technos={ProjectDetail.technos}
                github={ProjectDetail.github}
                external={ProjectDetail.external}
            />
        
        ));

        
        const pagesNumber = [];
        for (let i = 1; i<= Math.ceil(projects.length /projectPerPage ); i++){
            pagesNumber.push(i);  
        }


        const renderPageNumbers = pagesNumber.map((number,index) => (
                
            <StyledPaginationItem key={index} active={ currentPage === number}>
                <StyledPaginationLink 
                    key={number}
                    id={number}
                    onClick={handleClick}
                >
                    { number }
                </StyledPaginationLink>
            </StyledPaginationItem>
            
        ));
        
        

        return (
            <>          
                
                <StyledContainer>
                    <Heading> Mes projets ({projects.length}) </Heading>
                    <StyledFlexContainer>

                        
                            {renderProject}

                        
                        
                    </StyledFlexContainer>

                    <StyledPagination >

                        <StyledPaginationItem style={{ marginRight: '20px' }}>
                            <StyledPaginationLink className="prev" previous onClick={handlePrev} />
                        </StyledPaginationItem>


                        {renderPageNumbers}


                        <StyledPaginationItem style={{ marginLeft: '20px' }}>
                            <StyledPaginationLink className="next" next onClick={handleNext} />
                        </StyledPaginationItem>

                    </StyledPagination>
                  
                </StyledContainer>

                

        </> 
        )
    
};

export default Projects;